import { render, staticRenderFns } from "./PeopleAvatarWithMenu.vue?vue&type=template&id=346a08f2&scoped=true&"
import script from "./PeopleAvatarWithMenu.vue?vue&type=script&lang=js&"
export * from "./PeopleAvatarWithMenu.vue?vue&type=script&lang=js&"
import style0 from "./PeopleAvatarWithMenu.vue?vue&type=style&index=0&id=346a08f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a08f2",
  null
  
)

export default component.exports